import * as React from 'react';



export default class InfoActivity extends React.Component {
  constructor(props){
    super(props);
  }
  render() {
    return (
      <svg className={this.props.className} xmlnsXlink="http://www.w3.org/1999/xlink" width="16" height="16" viewBox="0 0 16 16" fill="none">
        <path fillRule="evenodd" clipRule="evenodd" d="M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16ZM8.8128 4.1888C8.8128 4.63254 8.45226 4.9792 8.00853 4.9792C7.57866 4.9792 7.20426 4.63254 7.20426 4.1888C7.20426 3.74507 7.57866 3.38454 8.00853 3.38454C8.45226 3.38454 8.8128 3.74507 8.8128 4.1888ZM8.6464 6.1024V12.8H7.3984V6.1024H8.6464Z" fill="#54B6E7"/>
      </svg>
    )
  }
}
